import React, { useState, useEffect } from "react";
import "./css/userReg.css";
import { Breadcrumb, Button, Layout, Menu, theme } from "antd";
import { BrowserRouter as Router, Route, Link } from "react-router-dom";
import NavImg from "./images/icons/nav.png"

// import ComboBox from 'shersoft-combobox';
import Sidebar from "./sideBar"; // Import the Sidebar component
// import itemReg from "./CategoryReg";

const { Header, Content, Footer } = Layout;

const UserReg = () => {

	const api_base_url = process.env.REACT_APP_API_BASE_URL

	const [editKOT, setEditKOT] = useState(true); // Initialize state to true as per the initial 'checked' attribute
	const [Cancel_KOT, setCancel_KOT] = useState(true);
	const [Move_Table, setMove_Table] = useState(true);
	const [Generate_Bill, setGenerate_Bill] = useState(true);
	const [Pending_Bill, setPending_Bill] = useState(true);
	const [New_Tables, setNew_Tables] = useState(true);
	const [Allow_Discount, setAllow_Discount] = useState(true);
	const [only_opened_Table, setonly_opened_Table] = useState(true);
	const [Allow_Special_Discount, setAllow_Special_Discount] = useState(true);
	const [All_Tables, setAll_Tables] = useState(true);
	const [collapsed, setCollapsed] = useState(false);
	const [signupSuccess, setSignupSuccess] = useState(false);
	const [dateTime, setDateTime] = useState(new Date());
	const [formData, setFormData] = useState({
		userFullName: "",
		userMob: "",
		userEmail: "",
		userType: "",
		userName: "",
		userPassword: "",
		companyName: "",
	});
	const [errors, setErrors] = useState({
		userEmail: "",
		userMob: "",
		userPassword: "",
	});


	const handlesetEditKOTChange = (e) => {
		setEditKOT(e.target.checked);
	};

	const handlesetCancel_KOTChange = (e) => {
		setCancel_KOT(e.target.checked);
	};
	const handlesetMove_TableChange = (e) => {
		setMove_Table(e.target.checked);
	};
	const handlesetGenerate_BillChange = (e) => {
		setGenerate_Bill(e.target.checked);
	};
	const handlesetPending_BillChange = (e) => {
		setPending_Bill(e.target.checked);
	};
	const handlesetNew_TablesChange = (e) => {
		setNew_Tables(e.target.checked); // Update state on checkbox change
	};
	const handlesetAllow_DiscountChange = (e) => {
		setAllow_Discount(e.target.checked);
	};
	const handlesetAllow_Special_DiscountChange = (e) => {
		setAllow_Special_Discount(e.target.checked);
	};
	const handlesetonly_opened_TableChange = (e) => {
		setonly_opened_Table(e.target.checked);
	};
	const handlesetAll_TablesChange = (e) => {
		setAll_Tables(e.target.checked);
	};

	const validateEmail = (userEmail) => {
		// Basic email validation
		const pattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
		return pattern.test(userEmail);
	};

	const validateMobilenumber = (userMob) => {
		// Check for 10-digit number
		return /^\d{10}$/.test(userMob);
	};

	const validatePassword = (userPassword) => {
		// Check for minimum 8 characters
		return userPassword.length >= 8;
	};

	const toggleSidebar = () => {
		setCollapsed(!collapsed);
	};

	const handleSubmit = async (event) => {
		event.preventDefault();
		// //("submit button clicked");

		const {
			userFullName,
			userMob,
			userEmail,
			userType,
			userName,
			userPassword,
			companyName
		} = formData;

		const emailValid = validateEmail(userEmail);
		const mobilenumberValid = validateMobilenumber(userMob);
		const passwordValid = validatePassword(userPassword);

		if (!emailValid) {
			setErrors({ ...errors, userEmail: "Invalid email address." });
			alert(
				"Invalid E-Mail Address"
			)
		} else if (!mobilenumberValid) {
			setErrors({ ...errors, userMob: "Invalid mobile number." });
			alert(
				"Invalid Mobile Number"
			)
		} else if (!passwordValid) {
			setErrors({
				...errors,
				userPassword: "Password must be at least 8 characters long.",
			});
			alert(
				"Invalid password"
			)
		} else {
			try {
				const response = await fetch(`${api_base_url}/userTypeRegistration`, {
					method: "POST",
					headers: {
						"Content-Type": "application/json",
					},
					body: JSON.stringify({
						userFullName,
						userMob,
						userEmail,
						userType,
						userName,
						userPassword,
						companyName
					}),
				});

				if (response.ok) {
					// Registration successful
					setSignupSuccess(true); // Set the signup success state
					setFormData({
						// Clear form data
						userFullName: "",
						userMob: "",
						userEmail: "",
						userType: "",
						userName: "",
						userPassword: "",
						companyName: "",
					});
				} else {
					// Registration failed
					console.error("Registration failed");
				}
			} catch (error) {
				console.error("Error connecting to the server:", error);
			}
		}
	};

	useEffect(() => {
		const handleWindowResize = () => {
			if (window.innerWidth <= 768) {
				setCollapsed(true);
			} else {
				setCollapsed(false);
			}
		};

		window.addEventListener("resize", handleWindowResize);

		return () => {
			window.removeEventListener("resize", handleWindowResize);
		};
	}, []);
	useEffect(() => {
		// Update totalValue state
		const intervalId = setInterval(() => {
			setDateTime(new Date());
		}, 1000);
		return () => clearInterval(intervalId);
	});

	//time
	const formattedDateTime = dateTime.toLocaleString();
	// Function to handle input changes
	const handleInputChange = (event, setInputValue) => {
		setInputValue(event.target.value);
	};

	return (
		<div className="userRegMainDiv">
			<div className='userRegNavBar_KOT'>
				<div className='NavBar_KOT_Logo_Btn'>
					<img src={NavImg} alt="?" />
					<span className='TitleText_KOT'>SherDine</span>
				</div>
				<div className='DateTime'>
					{formattedDateTime}
				</div>
			</div>
			<div className="UserRegContentPart">
				<div className="UserRegContentSideBarLeft">
				</div>
				<div className="userRegFormDiv">
					<div className="UserRegSidebar">
						<div className="PathUserPageDiv">
							new
						</div>
					</div>
					<form className="userRegform" onSubmit={handleSubmit}>
						<div className="userRegformContent">
							<div className="userRegformLeft">
								<div className="userRegformLeftDivName">
									<label className="userRegformLeftName">
										Name
									</label>
									<input
										className="userRegformName"
										type="text"
										value={formData.userFullName}
										onChange={(e) =>
											setFormData({ ...formData, userFullName: e.target.value })
										}
									/>
								</div>
								<div className="userRegformLeftDivUserName">
									<label className="userRegformLeftUserName">
										User Name
									</label>
									<input
										className="userRegformUserName"
										type="text"
										value={formData.userName}
										onChange={(e) =>
											setFormData({ ...formData, userName: e.target.value })
										}
									/>
								</div>
								<div className="userRegformLeftDivPass">
									<label className="userRegformLeftPass">
										Password
									</label>
									<input
										className="userRegformPassword"
										type="text"
										value={formData.userPassword}
										onChange={(e) =>
											setFormData({ ...formData, userPassword: e.target.value })
										}
									/>
								</div>
								<div className="userRegformLeftDivUserPass">
									<label className="userRegformLeftUserPass">
										User Password
									</label>
									<input
										className="userRegformUserPassword"
										type="text"
										value={formData.userPassword}
										onChange={(e) =>
											setFormData({ ...formData, userPassword: e.target.value })
										}
									/>
								</div>
							</div>
							<div className="userRegformRight">
								<div className="userRegformRightUserType">
									<label className="userRegformRightUserTypeDiv">
										User Type
									</label>
									<input
										className="userRegformUserType"
										type="text"
										value={formData.userType}
										onChange={(e) =>
											setFormData({ ...formData, userType: e.target.value })
										}
									/>
								</div>
								<div className="userRegformRightUserCode">
									<label className="userRegformRightUserCodeDiv">
										User Code
									</label>
									<input
										className="userRegformUserCode"
										type="text"
										value={formData.userMob}
										onChange={(e) =>
											setFormData({ ...formData, userMob: e.target.value })
										}
									/>
								</div>
								<div className="userRegformRightPhone">
									<label className="userRegformRightPhoneDiv">
										Phone
									</label>
									<input
										className="userRegformPhone"
										type="number"
										value={formData.userMob}
										onChange={(e) =>
											setFormData({ ...formData, userMob: e.target.value })
										}
									/>
								</div>
								<div className="userRegformRightPhone">
									<label className="userRegformRightPhoneDiv">
										CompanyName
									</label>
									<input
										className="userRegformPhone"
										type="text"
										value={formData.companyName}
										onChange={(e) =>
											setFormData({ ...formData, companyName: e.target.value })
										}
									/>
								</div>
								<div className="userRegformRightSwipeCode">
									<label className="userRegformRightSwipeCodeDiv">
										Swipe Code
									</label>
									<input
										className="userRegformSwipeCode"
										type="email"
										value={formData.userEmail}
										onChange={(e) =>
											setFormData({ ...formData, userEmail: e.target.value })
										}
									/>
								</div>
							</div>
						</div>
						
						<div className="UserRegContentBtns">
							<button type="button" className="btn btn-outline-light UserRegContentCancelBtn">
								Cancel
							</button>
							<button type="submit" className="btn btn-outline-danger UserRegContentSubmitBtn">
								Submit
							</button>
						</div>
					</form>
				</div>
			</div>			
		</div>
	);
};
export default UserReg;
